import React, { Component } from 'react';
import Pagination from 'react-bootstrap/Pagination';
import './Pagination.css';

class PaginationBar extends Component {
  jumpTo(pageNo) {
    const { setPageNumber } = this.props;
    setPageNumber(pageNo);
  }

  render() {
    const { totalPages, currentPage, lastPage } = this.props;
    const pages = [];
    for (let i = 1; i <= totalPages; i += 1) {
      pages.push(i);
    }
    const selectOption = (
      <>
        {pages.map((element, index) => (
          <Pagination.Item
            active={currentPage === index}
            onClick={() => this.jumpTo(index)}
          >
            {index}
          </Pagination.Item>
        ))}
      </>
    );

    return (
      <div className="PaginationBarContainer">

        <div style={{
          margin: 'auto',
          width: "90%",
          overflow: "scroll",
          border: "1px solid #dee2e6",
          padding: 10
        }}>
          <Pagination style={{ marginBottom: 0 }}>
            <Pagination.First
              onClick={() => this.jumpTo(1)}
              disabled={currentPage - 1 === 0}
            />
            <Pagination.Prev
              onClick={() => this.jumpTo(currentPage - 1)}
              disabled={currentPage - 1 === 0}
            />
            {selectOption}
            <Pagination.Next
              onClick={() => this.jumpTo(currentPage + 1)}
              disabled={currentPage === lastPage}
            />
            <Pagination.Last
              onClick={
                () => this.jumpTo(lastPage)
              }
              disabled={currentPage === lastPage}
            />
          </Pagination>

        </div>
      </div>
    );
  }
}

export default PaginationBar;
